define( function() {
	return ( /^margin/ );
} );



// WEBPACK FOOTER //
// ./~/jquery/src/css/var/rmargin.js